export type BadgeColor = 'primary' | 'white' | 'secondary';

export const BADGE_MAX_COUNT = 99;

export const BADGE_COLOR_CLASSES: Record<BadgeColor, string> = {
  primary: 'bg-primary-600 text-white',
  white: 'bg-secondary-50 text-primary-900',
  secondary: 'bg-secondary-100 text-secondary-600',
};
